

import "../../Foundation/stylable/colors.st.css.js";
import "./useOverlayScrollbar.initialization.st.css.js";
import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_224_0_useOverlayScrollbar";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_224_0_useOverlayScrollbar__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-scrollbar-fill":"--wds-scrollbar-fill","wds-scrollbar-fill-hover":"--wds-scrollbar-fill-hover","wds-scrollbar-fill-active":"--wds-scrollbar-fill-active","wds-border-radius-full":"--wds-border-radius-full","wds-space-padding-vertical-x-tiny":"--wds-space-padding-vertical-x-tiny","wds-space-padding-horizontal-xx-tiny":"--wds-space-padding-horizontal-xx-tiny","scrollbar-size":"--scrollbar-size","scrollbar-padding-y":"--scrollbar-padding-y","scrollbar-padding-x":"--scrollbar-padding-x","scrollbar-handle-border-radius":"--scrollbar-handle-border-radius","scrollbar-handle-bg":"--scrollbar-handle-bg","scrollbar-handle-bg-hover":"--scrollbar-handle-bg-hover","scrollbar-handle-bg-active":"--scrollbar-handle-bg-active","scrollbar-handle-interactive-area-offset":"--scrollbar-handle-interactive-area-offset"}; 




